import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/waitinglist/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: "2rem",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <div style={{ marginBottom: "2rem" }}>
        Thank you for your interest. Currently we are invite only.
      </div>
      <div style={{ fontSize: "1.5rem" }}>
        Reach out to{" "}
        <a
          href="http://x.com/mies"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#3366cc", textDecoration: "underline" }}
        >
          Mies
        </a>{" "}
        to get an invite
      </div>
    </div>
  );
}
